import { Button } from 'styled';

import Model from 'components/Modal';
import { deleteDocumentById } from 'apis/customApiHandler';
import { useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { saveErrorCreationEvent } from '../../utils/analytics';
import { ANALYTICS_EVENTS } from 'utils/analyticsEvents';
import { useLocation } from 'react-router-dom';

const Delete = ({ handleClick, id, getData }) => {
  const queryClient = useQueryClient();
  const location = useLocation();

  function dtpDeleteEventFunc(eventName, params) {
    return saveErrorCreationEvent(eventName, "Delete DTP Plan", "DTP Planning", location.pathname, params);
  }

  const handleClickDelete = async (id) => {
    dtpDeleteEventFunc(ANALYTICS_EVENTS.CLICK_DELETE_CHANGES, { deleted_dtp_id: id });
    try {
      const data = await deleteDocumentById('dtp-planning', id);
      if (data) {
        dtpDeleteEventFunc(ANALYTICS_EVENTS.SYS_DELETE_DTP_PLANNING_SUCCESS, { deleted_dtp_id: id });
        toast.success('Successfully deleted');
        queryClient.invalidateQueries('dtp-plannings');
        handleClick();
        getData();
      }
    } catch (error) {
      const errMsg = error?.response?.data?.message || error?.message;
      dtpDeleteEventFunc(ANALYTICS_EVENTS.SYS_DELETE_DTP_PLANNING_ERROR, { deleted_dtp_id: id, errMsg });
    }
  };

  return (
    <Model
      handleClick={handleClick}
      title={'Delete DTP Plan'}
      className="max-w-2xl"
    >
      <div className="p-4">
        <p className="text-red-500 p-5 text-center">
          Are you sure you want to delete this DTP Plan
        </p>

        <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            No
          </Button>
          <Button type="button" bgPrimary onClick={() => handleClickDelete(id)}>
            Yes
          </Button>
        </div>
      </div>
    </Model>
  );
};

export default Delete;
